export default "__VITE_ASSET__CN5AUHnA__"